import React from 'react';
import '../App.css';
import AvatarEditor from 'react-avatar-editor';

export default class ProfileImageUploader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {scale: 1.0, rotation: 0};
  }

  handleUpload(event) {
    event.preventDefault();
    console.log('Handle file uplaod event...');
  }

  scaleImage(event) {
    event.preventDefault();
    console.log('Scaling image... value is: ' + event.target.value);
    this.setState({scale: event.target.value});
  }

  rotateImage(event, dir) {
    event.preventDefault();
    let rotation = this.state.rotation || 0;
    if (dir === 'left') {
      rotation -= 90;
    } else {
      rotation += 90;
    }
    this.setState({rotation: rotation});
  }

  onClickSave(event) {
    console.log('Save button clicked...');
    event.preventDefault();
    if (this.editor) {
      const canvasScaled = this.editor.getImageScaledToCanvas()
      let that = this;
      this.setState({imgFile: canvasScaled, binFile: canvasScaled}, function() {
        that.props.finish();
      });
    } else {
      console.log('Editor is not defined!');
    }
  }

  setEditorRef = (editor) => this.editor = editor;

  handleFileChange(e) {
    console.log('HandleFileChange got fired!');
    e.preventDefault();
    this.setState({ file: e.target.files[0], imgFile: e.target.files[0], binFile: e.target.files[0] }, function () {
    }); 
  }

  render() {
    return (
      <div className='greyOverlay'>
        <div className='imagePreview' />
        <div className='basicModal' style={{width: '256px', height: '362px'}}>
          Drag and drop profile image<br />
          <AvatarEditor 
               image={this.state.imgFile || "http://example.com/initialimage.jpg"}
               ref={this.setEditorRef} 
               width={250} height={250} border={2} color={[205, 215, 225, 0.6]} 
               scale={this.state.scale} rotate={this.state.rotation} 
          />
          <br />
          Zoom: <input step={0.1} value={1.2} type='range' min={0} max={4} onChange={(e) => this.scaleImage(e)} />
          <br />
          Rotate: 
          <button onClick={(e) => this.rotateImage(e, 'left')}>&#8592;</button>
          <button onClick={(e) => this.rotateImage(e, 'right')}>&#8594;</button>
          <div className='commentButtons' style={{marginTop: '6px'}}>
            <input type='file' onChange={(e) => this.handleFileChange(e)} />
            <button className='smallCancelButton' onClick={(e) => this.props.finish()}>Cancel</button>
            <button className='smallSubmitButton' onClick={(e) => this.onClickSave(e)}>OK</button>
          </div>
        </div>
      </div>
    );
  }
}
